import React from 'react';
import { Icon, Typography } from "../../ecosystem";

const SuccessMsg = ({
    message,
}) => {

    return (
        <div className='proxy-home-success-msg'>
            <Icon name="check" color="$color-system-a1" />
            <Typography type="body-01">{message}</Typography>
        </div>
    );
}

export default SuccessMsg;
